import { useState } from 'react';

const ETHNICITY_OPTIONS = {
  female: [
    { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animegirletnicity1.webp', name: 'European' },
    { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animegirletnicity2.webp', name: 'Asian' },
    { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animegirletnicity3.webp', name: 'Arab' },
    { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animegirletnicity4.webp', name: 'Ebony' },
    { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animegirletnicity5.webp', name: 'Latino' }
  ],
  male: [
    { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animeboyetnicity1.webp', name: 'European' },
    { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animeboyetnicity2.webp', name: 'Asian' },
    { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animeboyetnicity3.webp', name: 'Arab' },
    { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animeboyetnicity4.webp', name: 'Ebony' },
    { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animeboyetnicity5.webp', name: 'Latino' }
  ],
  trans: [
    { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animetransetnicity1.webp', name: 'European' },
    { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animetransetnicity2.webp', name: 'Asian' },
    { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animetransetnicity3.webp', name: 'Arab' },
    { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animetransetnicity4.webp', name: 'Ebony' },
    { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/animetransetnicity5.webp', name: 'Latino' }
  ],
  creature: [
    { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/etnicityEarth.webp', name: 'Earth', description: 'Yellow horned reptilian demon, snarling.' },
    { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/etnicityJupiter.webp', name: 'Jupiter', description: 'Sleek blue alien, muscular, menacing.' },
    { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/etnicityMars.webp', name: 'Mars', description: 'Dragon hybrid, winged, demonic, scaled, glowing-eyed.' },
    { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/etnicityMercury.webp', name: 'Mercury', description: 'Seductive horned reptilian demoness, glowing-eyed.' },
    { url: 'https://cdn.lovescape.com/cdn/front/images/marketing/etnicityVenus.webp', name: 'Venus', description: 'Blue winged demoness, glowing-eyed, alluring.' }
  ]
};

const HEADINGS = {
  female: 'Choose Her Ethnicity',
  male: 'Choose His Ethnicity',
  trans: 'Choose Their Ethnicity',
  creature: 'Choose Ethnicity'
};

const Step2Ethnicity = ({ formData, updateFormData, goToStep }) => {
  const [selectedEthnicity, setSelectedEthnicity] = useState(formData.extraFields.ethnicity || '');
  const options = ETHNICITY_OPTIONS[formData.gender] || [];
  const heading = HEADINGS[formData.gender] || 'Choose Ethnicity';
  const isCreature = formData.gender === 'creature';

  const handleSelect = (ethnicityName, description) => {
    setSelectedEthnicity(ethnicityName);
    // For creature, store the description in extraFields
    if (isCreature && description) {
      updateFormData('extraFields.ethnicity', `${ethnicityName}: ${description}`);
    } else {
      updateFormData('extraFields.ethnicity', ethnicityName);
    }
  };

  const handleNext = () => {
    if (selectedEthnicity) {
      goToStep(3);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '100px 20px 40px',
      position: 'relative',
      overflowY: 'auto'
    }}>
      {/* Background images */}
      <img 
        src="https://customer-assets.emergentagent.com/job_d690f70b-574f-42dc-be44-392b85b82530/artifacts/s2zgc1ad_nowings.png" 
        alt="Background Left" 
        className="bg-image-left"
      />
      <img 
        src="https://customer-assets.emergentagent.com/job_d690f70b-574f-42dc-be44-392b85b82530/artifacts/h9eorbzw_female6.png" 
        alt="Background Right" 
        className="bg-image-right"
      />
      <img 
        src="https://customer-assets.emergentagent.com/job_d690f70b-574f-42dc-be44-392b85b82530/artifacts/i4w18itu_9.png" 
        alt="Background Center" 
        className="bg-image-center"
      />

      <h1 style={{
        fontSize: 'clamp(36px, 6vw, 56px)',
        marginBottom: '60px',
        letterSpacing: '4px',
        textAlign: 'center',
        color: '#ffffff',
        fontWeight: 'bold',
        position: 'relative',
        zIndex: 1
      }} data-testid="step2-heading">
        {heading}
      </h1>

      <div style={{
        display: 'flex',
        justifyContent: 'center',
        overflowX: 'auto',
        gap: '24px',
        width: '100%',
        maxWidth: '1200px',
        padding: '20px',
        scrollbarWidth: 'thin',
        position: 'relative',
        zIndex: 1
      }}>
        {options.map((option, index) => (
          <div
            key={index}
            style={{
              minWidth: '200px',
              flexShrink: 0,
              textAlign: 'center'
            }}
          >
            <div
              className={`media-item ${selectedEthnicity === option.name ? 'selected' : ''}`}
              onClick={() => handleSelect(option.name, option.description)}
              style={{
                width: '200px',
                height: '280px',
                borderRadius: '12px',
                overflow: 'hidden',
                marginBottom: '12px'
              }}
              data-testid={`ethnicity-option-${index}`}
            >
              <img src={option.url} alt={option.name} />
            </div>
            <div style={{
              fontSize: '18px',
              color: '#ffffff',
              fontWeight: 'bold'
            }}>
              {option.name}
            </div>
          </div>
        ))}
      </div>

      <button
        className="btn-primary"
        onClick={handleNext}
        disabled={!selectedEthnicity}
        style={{
          marginTop: '60px',
          position: 'relative',
          zIndex: 1
        }}
        data-testid="step2-next-button"
      >
        Next
      </button>
    </div>
  );
};

export default Step2Ethnicity;